import { render, staticRenderFns } from "./CatalogClientObject.vue?vue&type=template&id=08995b36&scoped=true&"
import script from "./CatalogClientObject.vue?vue&type=script&lang=ts&"
export * from "./CatalogClientObject.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogClientObject.vue?vue&type=style&index=0&id=08995b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08995b36",
  null
  
)

export default component.exports